import React from "react";

const AboutBg = () => {
    return (
        <div className="min-h-screen w-screen absolute top-0 left-0 grid">
            <img src={require('../assets/images/about_bg.png')} 
                alt="Background"
                className="w-full h-full max-w-full object-cover" />
        </div>
    );
}

export default AboutBg;